export default from './Message';



// WEBPACK FOOTER //
// ./src/sharedComponents/Chat/components/Messages/components/Message/index.js